import React from "react";
import { Link } from "react-router-dom";
import "./project.css";
import craft from "../crafts.mp4";

const Projects = () => {
    return (
        <div className="container">
            <div className="nav-left nav-left-alt">
                <div className="nav-left-item">
                    <Link to="/work" className="nav-left-link is-black">
                        WORK
                    </Link>
                </div>

                <div className="nav-line is-black"></div>

                <div className="nav-left-item nav-copyright">
                    <div class="copyright">©/2022</div>
                </div>
            </div>

            <div className="content content-work">
                <div className="header-mask header-mask-large">
                    <h1 className="header header-large">Store App</h1>
                </div>
            </div>

            <div className="wrapper wrapper-small wf-section">
                <div className="work-container">
                    <div className="description-mask">
                        <p className="description description-large">
                            Fully responsive E-commerce Web App
                        </p>
                    </div>
                    <figure className="w-richtext-figure-type-image w-richtext-align-fullwidth">
                        <div>
                            <img
                                src="https://i.ibb.co/DRsmdrY/forporfoliostore.jpg"
                                alt="projectimg"
                            />
                        </div>
                    </figure>
                    <p>
                        On this project i used, Stripe as the payment processing
                        platform, Sanity.io for content managing, file storage
                        and databases, Framer Motion for animations.
                        <br />
                        <a
                            href="https://github.com/Mileristov/Crafts-and-Candles"
                            target="_blank"
                            rel="noreferrer"
                            class="link-blue"
                        >
                            See on Github.
                        </a>
                    </p>

                    <p>
                        State Managment using React Context API, Advanced cart
                        functionality and Next.js server-side rendering.
                    </p>
                </div>
            </div>
            <div className="videos">
                <div className="laptop">
                    <div className="video w-embed">
                        <video
                            width={"100%"}
                            height="auto"
                            autoPlay
                            loop
                            playsInline
                            muted
                        >
                            <source src={craft} type="video/mp4"></source>
                        </video>
                    </div>
                </div>
            </div>
            <div className="wrapper wrapper-small wf-section">
                <div className="content-footer">
                    <blockquote class="call-to-action">
                        Check it out.
                    </blockquote>
                    <a
                        href="https://crafts-and-candles.vercel.app/"
                        target="_blank"
                        rel="noreferrer"
                        class="button w-button"
                    >
                        https://crafts-and-candles.vercel.app/
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Projects;
